import { supabase } from "@/services/supabase/createClient";

export const sendEmailInvite = async (email: string, teamId: string) => {
  const { error } = await supabase.functions.invoke("bff/api/teams/send_invite", {
    method: "POST",
    body: { email, team_id: teamId },
  });

  return { error };
};
